import { render, staticRenderFns } from "./workspace-organization-card.vue?vue&type=template&id=9d420bca&scoped=true&"
import script from "./workspace-organization-card.vue?vue&type=script&lang=js&"
export * from "./workspace-organization-card.vue?vue&type=script&lang=js&"
import style0 from "./workspace-organization-card.vue?vue&type=style&index=0&id=9d420bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d420bca",
  null
  
)

export default component.exports